module.exports = __webpack_public_path__ + "static/media/game-planning.9e300815.svg";